import React from 'react';
import { connect } from 'react-redux';
import { setConfig } from '../../actions/config';
import { push } from 'react-router-redux';

class ToggleRightSidebar extends React.Component {
  constructor(props) {
    super(props);
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
    this.redirectToTaskClock = this.redirectToTaskClock.bind(this);
  }

  toggleRightSidebar() {
    this.props.setConfig('rightSidebar', !this.props.config.rightSidebar);
  }

  redirectToTaskClock() {
    this.props.goToTaskClock();
  }

  render() {
    const style = {
      fontSize: '20px',
      paddingTop: '5px',
    };

    if ((this.props.users && this.props.users.userProfile === null) || Object.keys(this.props.users).length === 0) {
      return null;
    }

    return (
      <ul className="nav nav-inline nav-inline-2">
        <li className="nav-item">
          <a
            className="nav-link toggle-right-sidebar"
            onClick={this.toggleRightSidebar}>
            <i className="material-icons" style={style}>account_box</i>
          </a>
        </li>
        <li className="nav-item">
          <a
            className="nav-link toggle-right-sidebar"
            onClick={this.redirectToTaskClock}>
            <i className="material-icons" style={style}>alarm</i>
          </a>
        </li>
      </ul>
    )
  }
};

const mapStateToProps = (state, ownProps) => {
  return {
    config: state.config,
    auth: state.auth,
    users: state.users
  }
};

const mapDispatchToProps = dispatch => {
  return {
    setConfig: (key, value) => dispatch(setConfig(key, value)),
    goToTaskClock: () => {
      dispatch(push('/pages/task-clock'));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ToggleRightSidebar);



// WEBPACK FOOTER //
// ./src/elements/navbar-1/ToggleRightSidebar.js